/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Filter_DocumentsInputs */

const en_home_v2_filter_documents = /** @type {(inputs: Home_V2_Filter_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

const es_home_v2_filter_documents = /** @type {(inputs: Home_V2_Filter_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Home_V2_Filter_DocumentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_filter_documents = /** @type {((inputs?: Home_V2_Filter_DocumentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Filter_DocumentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_filter_documents(inputs)
	return en_home_v2_filter_documents(inputs)
});